export const generateCryptoCode = (length = 6) => {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const randomChars = Array.from(
    crypto.getRandomValues(new Uint8Array(length)),
    (x) => charset[x % charset.length]
  );

  return `${randomChars.slice(0, 3).join('')}-${randomChars.slice(3).join('')}`;
};

export const extractOrderIdFromUrl = (): string | null => {
  const params = new URLSearchParams(document.location.search);
  return params.get('code');
};

export const setOrderPageTitle = (code: string) => {
  document.title = `Auftragsstatus ${code} | ScanLab`;
}

export const delay = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const fakeOrderCode = async () => {
  await delay(1000);
  return { code: 'ABCD-EFGH-IJKL' };
};
